@if (bas.envtest) {
  <div class="text-center">
    tools.page (test)
  </div>
}
